import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/** Действие, навешанное на ту или иную кнопку панели инструментов. */
let DxListToolbarAction = class DxListToolbarAction {
    /** Действие, навешанное на ту или иную кнопку панели инструментов. */
    constructor() {
        /**
         * Обусловлена ли возможность выполнения действия наличием одного и только одного выбранного элемента списка.
         */
        this._isSingleItemAction = false;
        /**
         * Обусловлена ли возможность выполнения действия наличием нескольких выбранных элементов списка.
         */
        this._isMultiItemAction = false;
        /**
         * Обусловлена ли возможность выполнения действия наличием одного и только одного выбранного элемента списка.
         */
        this._isSelectionIndependent = false;
        // TODO: Придумать для этого флага название по-лучше! Пока у меня фонтазия иссякла :(
        /**
         * Возможность выполнения действия должна определятся при появлении выделения,
         * путем прогона критериев для каждого элемента выделения.
         */
        this._isSelectionDependent = false;
    }
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
    }
    get isSingleItemAction() {
        return this._isSingleItemAction;
    }
    set isSingleItemAction(value) {
        this._isSingleItemAction = value;
    }
    get isMultiItemAction() {
        return this._isMultiItemAction;
    }
    set isMultiItemAction(value) {
        this._isMultiItemAction = value;
    }
    get isSelectionIndependent() {
        return this._isSelectionIndependent;
    }
    set isSelectionIndependent(value) {
        this._isSelectionIndependent = value;
    }
    get isSelectionDependent() {
        return this._isSelectionDependent;
    }
    set isSelectionDependent(value) {
        this._isSelectionDependent = value;
    }
    get args() {
        return this._args;
    }
    set args(value) {
        this._args = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "type", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxListToolbarAction.prototype, "_type", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isSingleItemAction", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxListToolbarAction.prototype, "_isSingleItemAction", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isMultiItemAction", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxListToolbarAction.prototype, "_isMultiItemAction", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isSelectionIndependent", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxListToolbarAction.prototype, "_isSelectionIndependent", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isSelectionDependent", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxListToolbarAction.prototype, "_isSelectionDependent", void 0);
DxListToolbarAction = tslib_1.__decorate([
    jsonObject
], DxListToolbarAction);
export { DxListToolbarAction };
